<template>
  <f7-page class="page-force-change-information">
    <f7-navbar title="ĐỔI THÔNG TIN BẮT BUỘC"></f7-navbar>
    <f7-list inset>
      <f7-list-input
          type="text"
          label="Tên hiển thị"
          outline
          floating-label
          placeholder="Tên hiển thị"
          :value="form_secret.fullname"
          @input="form_secret.fullname = $event.target.value"
      >
        <f7-icon slot="media" ios="f7:person_circle"></f7-icon>
      </f7-list-input>
    </f7-list>
    <f7-list inset>
      <f7-list-input
          type="password"
          placeholder="Mật khẩu cũ"
          :value="form_password.old_password"
          @input="form_password.old_password = $event.target.value"
      >
        <f7-icon slot="media" ios="f7:person"></f7-icon>
      </f7-list-input>
      <f7-list-input
          placeholder="Mật khẩu mới"
          type="password"
          pattern="[0-9]{8}"
          inputmode="numeric"
          maxlength="8"
          info="Mật khẩu gồm 8 số"
          :value="form_password.new_password"
          @input="form_password.new_password = $event.target.value"
      >
        <f7-icon slot="media" ios="f7:lock"></f7-icon>
      </f7-list-input>
      <f7-list-input
          placeholder="Nhập lại MK mới"
          type="password"
          pattern="[0-9]{8}"
          inputmode="numeric"
          maxlength="8"
          :value="form_password.new_password_confirmation"
          @input="form_password.new_password_confirmation = $event.target.value"
      >
        <f7-icon slot="media" ios="f7:lock"></f7-icon>
      </f7-list-input>
    </f7-list>
    <f7-list inset>
      <f7-list-input
          type="select"
          placeholder="Câu hỏi bảo mật 1"
          :value="form_secret.secret_question_1"
          @input="form_secret.secret_question_1 = $event.target.value"
      >
        <f7-icon ios="f7:question_square" slot="media"></f7-icon>
        <option :value="item" :selected="item === form_secret.secret_question_1"  v-for="(item, idx) in questions" :key="idx">{{ item }}</option>
      </f7-list-input>
      <f7-list-input
          type="text"
          placeholder="Trả lời"
          :value="form_secret.answer_secret_question_1"
          @input="form_secret.answer_secret_question_1 = $event.target.value"
      >
        <f7-icon ios="f7:quote_bubble" slot="media"></f7-icon>
      </f7-list-input>
      <f7-list-input
          type="select"
          placeholder="Câu hỏi bảo mật 1"
          :value="form_secret.secret_question_2"
          @input="form_secret.secret_question_2 = $event.target.value"
      >
        <f7-icon ios="f7:question_square" slot="media"></f7-icon>
        <option :value="item" :selected="item === form_secret.secret_question_2" v-for="(item, idx) in questions" :key="idx">{{ item }}</option>
      </f7-list-input>
      <f7-list-input
          type="text"
          placeholder="Trả lời"
          :value="form_secret.answer_secret_question_2"
          @input="form_secret.answer_secret_question_2 = $event.target.value"
      >
        <f7-icon ios="f7:quote_bubble" slot="media"></f7-icon>
      </f7-list-input>
    </f7-list>
    <f7-block class="mt-1">
      <f7-button fill color="red" @click.prevent="submitChange">ĐỔI THÔNG TIN</f7-button>
    </f7-block>
  </f7-page>
</template>
<script>
import {mapState} from 'vuex';

export default {
  computed  :{
    ...mapState(['user_info'])
  },
  data(){
    return {
      form_password:{
        old_password             :'',
        new_password             :'',
        new_password_confirmation:''
      },
      form_secret  :{
        fullname                :'',
        secret_question_1       :'',
        answer_secret_question_1:'',
        secret_question_2       :'',
        answer_secret_question_2:'',
      },
      questions    :[
        'Biệt danh lúc nhỏ của bạn',
        'Tên đội thể thao yêu thích của bạn',
        '6 số cuối trong CMND/Passport',
        'Tên chú chó đầu tiên bạn nuôi',
        'Tên trường tiểu học mà bạn đã học',
        'Bạn thân của bạn thời thiếu niên',
        'Món ăn mà bạn thích nhất',
        'Bài hát yêu thích của bạn',
        'Người thầy đầu tiên của bạn',
        'Địa điểm mà bạn thích đến nhất'
      ],
    }
  },
  methods:{
    submitChange(){
      if(this.form_secret.secret_question_1 === this.form_secret.secret_question_2){
        this.$f7.dialog.alert('Vui lòng chọn 2 câu hỏi khác nhau', 'LỖI');
        return false;
      }

      this.$f7.preloader.show();

      this.$store.dispatch('updateUserInfo', this.form_secret)
          .then(() => {
            return this.$store.dispatch('changePassword', this.form_password);
          })
          .then(() => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert('Đã cập nhật thông tin thành công. Vui lòng đăng nhập lại', 'THÔNG BÁO', () => {
              this.$store.dispatch('logout');
              this.$f7.views.main.router.navigate('/dang-nhap');
            });
          })
          .catch((err) => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert(err, 'LỖI!');
          });
    },
  },
  mounted(){
    this.form_secret.fullname = this.user_info.fullname;
    this.form_secret.secret_question_1 = this._.isEmpty(this.user_info.secret_question_1) ? this.questions[0] : this.user_info.secret_question_1;
    this.form_secret.secret_question_2 = this._.isEmpty(this.user_info.secret_question_2) ? this.questions[1] : this.user_info.secret_question_2;
  }
};
</script>
